import { Card, CardContent } from "components/ui/card";
import { FileText, Store, DollarSign, AlertTriangle } from "lucide-react";
import { formatBRL } from "@/utils/money";
import type { TaxClosingTabs } from "@/services/tax-closing";

interface SummaryCardsRowProps {
  summary: TaxClosingTabs["summary"];
}

export function SummaryCardsRow({ summary }: SummaryCardsRowProps) {
  const cards = [
    {
      label: "Total de Notas",
      value: summary.totalNotes.toLocaleString("pt-BR"),
      icon: FileText,
      borderColor: "border-l-blue-500",
      iconBg: "bg-blue-50",
      iconColor: "text-blue-600",
    },
    {
      label: "Lojas Processadas",
      value: String(summary.totalStores),
      icon: Store,
      borderColor: "border-l-emerald-500",
      iconBg: "bg-emerald-50",
      iconColor: "text-emerald-600",
    },
    {
      label: "Nova Base ICMS Total",
      value: formatBRL(summary.totalNovaBaseIcms),
      icon: DollarSign,
      borderColor: "border-l-violet-500",
      iconBg: "bg-violet-50",
      iconColor: "text-violet-600",
    },
    {
      label: "Divergências",
      value: summary.divergenceCount.toLocaleString("pt-BR"),
      icon: AlertTriangle,
      borderColor: summary.divergenceCount > 0 ? "border-l-red-500" : "border-l-gray-300",
      iconBg: summary.divergenceCount > 0 ? "bg-red-50" : "bg-gray-50",
      iconColor: summary.divergenceCount > 0 ? "text-red-600" : "text-gray-400",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.label} className={`border-l-4 ${card.borderColor} hover:shadow-md transition-shadow`}>
          <CardContent className="py-5 px-5">
            <div className="flex items-start justify-between">
              <div className="flex flex-col gap-1">
                <p className="text-xs text-muted-foreground font-medium uppercase tracking-wider">
                  {card.label}
                </p>
                <p className="text-2xl font-bold tracking-tight">{card.value}</p>
              </div>
              <div className={`h-10 w-10 rounded-lg ${card.iconBg} flex items-center justify-center`}>
                <card.icon className={`h-5 w-5 ${card.iconColor}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
